import React from "react";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import Button from "../Button/Button";

export const FormButton = ({title, type, id}) => {

    return (
        <Button
            text={title}
            type={type}
            disabled={true}
            id={id}
            noIcon
        />
    )
}

const FormButtonErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>This component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <FormButton {...props}></FormButton>
        </ErrorBoundary>
    )
}

export default FormButtonErrors;